import React from 'react'
import styled from 'styled-components'

export type Props = {
  className?: string
  icon: string
  onClick?: () => void
  selected: boolean
}

export const I = styled<any>('i')`
  cursor: pointer;
  font-size: 34px;
  margin-bottom: 50px;
  opacity: ${props => props.selected ? 1 : 0.5};
  width: 34px;
`

export const Icon: React.SFC<Props> = ({ className, onClick, icon, selected }) => (
  <I onClick={onClick} className={`fa fa-${icon} ${className || ''}`} selected={selected} />
)
